import debounce from 'lodash.debounce';

export default class Slider {
  constructor(items) {
    this.slides = items;
    this.leftBtn = document.querySelector('.js-slider-left');
    this.rightBtn = document.querySelector('.js-slider-right');
    this.dots = document.getElementsByClassName('js-dot');
    this.itemsBox = document.querySelector('.js-box');
    this.items = document.querySelectorAll('.js-item');
    this.slideIndex = 1;
    this.interval = null;
    this.init();
    window.addEventListener(
      'resize',
      debounce(() => {
        this.setHeight();
      }),
      200
    );
  }

  setHeight() {
    if (this.items.length > 0) {
      let height = 0;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].clientHeight > height) {
          height = this.items[i].clientHeight;
        }
      }
      this.itemsBox.style.height = `${height}px`;
    }
  }

  init() {
    if (this.items[0].querySelector('img')) {
      const intervalLoad = setInterval(() => {
        if (
          this.items[0].querySelector('img').complete &&
          this.items[0].querySelector('img').complete.naturalHeight !== 0
        ) {
          this.setHeight();
          clearInterval(intervalLoad);
        }
      }, 500);
    } else {
      this.setHeight();
    }
    if (this.slides.length === 1) {
      this.slides[0].style.opacity = '1';
    } else if (this.slides.length > 1) {
      this.showSlides(this.slideIndex);
      window.addEventListener('load', () => {
        this.interval = setInterval(() => {
          this.plusSlides(1);
        }, 4000);
      });
    }

    if (!!this.leftBtn && !!this.rightBtn) {
      this.leftBtn.addEventListener('click', () => {
        this.plusSlides(-1);
      });
      this.rightBtn.addEventListener('click', () => {
        this.plusSlides(1);
      });

      for (let i = 0; i < this.dots.length; i++) {
        this.dots[i].addEventListener('click', () => {
          this.currentSlide(i + 1);
        });
      }
    }
  }

  plusSlides(n) {
    clearInterval(this.interval);
    this.showSlides((this.slideIndex += n));
    this.interval = setInterval(() => {
      this.plusSlides(1);
    }, 4000);
  }

  currentSlide(n) {
    clearInterval(this.interval);
    this.showSlides((this.slideIndex = n));
    this.interval = setInterval(() => {
      this.plusSlides(1);
    }, 4000);
  }

  showSlides(n) {
    for (let i = 0; i < this.slides.length; i++) {
      this.slides[i].style.opacity = '0';
      this.dots[i].classList.remove('zs-image-slider__dot--active');
      this.dots[i].classList.remove('zs-review-slider__dot--active');
    }

    if (n > this.slides.length) {
      this.slideIndex = 1;
      this.dots[this.slideIndex - 1].classList.add('zs-image-slider__dot--active');
      this.dots[this.slideIndex - 1].classList.add('zs-review-slider__dot--active');
    }

    if (n < 1) {
      this.slideIndex = this.slides.length;
      this.dots[this.slideIndex - 1].classList.add('zs-image-slider__dot--active');
      this.dots[this.slideIndex - 1].classList.add('zs-review-slider__dot--active');
    }

    this.slides[this.slideIndex - 1].style.opacity = '1';
    this.dots[this.slideIndex - 1].classList.add('zs-image-slider__dot--active');
    this.dots[this.slideIndex - 1].classList.add('zs-review-slider__dot--active');
  }
}
